import { FaCheckCircle } from "react-icons/fa";
import Button from "../Button";

const PremiumFeatures = ({ features, buttonText, onButtonClick }) => {
  return (
    
        <div className="rounded-lg border border-primary mb-4">
          <div className="p-4">
            <h5 className="text-light fw-bold mb-3">Premium Features</h5>

            {features.map((feature, idx) => (
              <div className="d-flex align-items-center mb-2" key={idx}>
                <FaCheckCircle className="text-accent me-2" size={16} />
                <small className="text-light">{feature}</small>
              </div>
            ))}

            <Button
              variant="gradient"
              onClick={onButtonClick}
              fullWidth
            >
              {buttonText}
            </Button>
          </div>
        </div>
     
  );
};

export default PremiumFeatures;